import { render, staticRenderFns } from "./TextAlignIcons.vue?vue&type=template&id=7ddc87af&scoped=true&"
import script from "./TextAlignIcons.vue?vue&type=script&lang=ts&"
export * from "./TextAlignIcons.vue?vue&type=script&lang=ts&"
import style0 from "./TextAlignIcons.vue?vue&type=style&index=0&id=7ddc87af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddc87af",
  null
  
)

export default component.exports